import FILTER_CONSTANTS from '../../../../constants/FilterConstants';
import { APPROVED_GL_POSTING_COLUMNS } from '../../../../constants/tableColumns';
import { WEEKLY_GL_POSTING_TEXT } from '../../constants';
import { useApprovedPostingTab } from './useApprovedPostingTab';
import PostingTabContent from '../../components/PostingTabContent';

const INITIAL_FILTER_PARAMS = FILTER_CONSTANTS.FILTER_DATA.APPROVED_GL_POSTING.INITIAL_PARAMS;
const INITIAL_FILTER_LENGTH = JSON.stringify(INITIAL_FILTER_PARAMS).length;

const ApprovedPostingTabContent = ({ filterSelector, setFilters, resetFilters }) => (
  <PostingTabContent
    columns={APPROVED_GL_POSTING_COLUMNS}
    filterSelector={filterSelector}
    setFilters={setFilters}
    resetFilters={resetFilters}
    emptyStateTitle={WEEKLY_GL_POSTING_TEXT.EMPTY_STATE_APPROVED}
    searchPlaceholder={WEEKLY_GL_POSTING_TEXT.SEARCH_PLACEHOLDER_APPROVED}
    initialFilterParams={INITIAL_FILTER_PARAMS}
    emptyFilterLength={INITIAL_FILTER_LENGTH}
    useTabHook={useApprovedPostingTab}
  />
);

ApprovedPostingTabContent.displayName = 'ApprovedPostingTabContent';

export default ApprovedPostingTabContent;
